import Box from "@mui/material/Box";
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";

// One search box looks through every data column. The Filters button adds a
// condition on a chosen column (name contains, age equals, and so on).
export default function ApplicantGridToolbar() {
  return (
    <GridToolbarContainer sx={{ px: 0.5, py: 1, gap: 1 }}>
      <GridToolbarFilterButton />
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarQuickFilter
        debounceMs={300}
        placeholder="Search all columns"
        sx={{ width: 280 }}
      />
    </GridToolbarContainer>
  );
}
